import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { createCppPartner } from '~/services/LuxLoyaltyService';

import type { CreatePartnerBody } from '~/types/costPerPoint';

import { costPerPointQueryKeys } from './costPerPointQueryKeys';

/**
 * Creates a partner.
 *
 * Invalidates the whole CPP tree rather than just the partner list: the rate-card, invoice and
 * partner-earn screens all offer partners in a dropdown, and each should see the new one.
 */
export function useCreateCppPartner() {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async (body: CreatePartnerBody) => {
      return await createCppPartner(body);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: costPerPointQueryKeys.all });
      enqueueSnackbar('Partner created', { variant: 'success' });
    },
    onError: (error: unknown) => {
      enqueueSnackbar(`Could not create partner: ${error instanceof Error ? error.message : 'unknown error'}`, {
        variant: 'error',
      });
    },
  });
}
